import React from "react";
import PropTypes from "prop-types";
import SambaPlayer from "./sambaPlayer";
import VimeoPlayer from "./vimeoPlayer";

const VideoPlayer = ({ player = "vimeo", ...props }) => {
  if (props.tokens.vimeo) {
    return <VimeoPlayer {...props} />;
  }

  if (!props.tokens.vimeo && player === "youtube") {
    return <iframe src={props.tokens.youtube} height="100%" title="Videoaula - Aprova Total" />;
  }

  return <SambaPlayer {...props} />;
};

VideoPlayer.propTypes = {
  loading: PropTypes.bool,
  player: PropTypes.oneOf(["samba", "vimeo", "youtube"]),
  tokens: PropTypes.exact({
    sambatech: PropTypes.string,
    vimeo: PropTypes.string,
    youtube: PropTypes.string
  }),
  // Threshold for onVirtualFinish to be called
  virtualFinishAt: PropTypes.number,

  onCreate: PropTypes.func,
  onStart: PropTypes.func,
  onFinish: PropTypes.func,

  // Called when the player has passed the virtualFinishAt threshold percentage
  onVirtualFinish: PropTypes.func,

  onError: PropTypes.func,

  // Called on every player tick
  // ({ duration, seconds }) => undefined
  onListen: PropTypes.func
};

export default VideoPlayer;
